module.exports = __webpack_public_path__ + "img/przeglad-w-abonamencie.d8950d63.png";